import store from './index'

export default {
  getUrl (key, systemConfig) {
    if (systemConfig) return systemConfig.endpoint[key]
    return store.state.endpoint.endPointConfig[key]
  }
}
